import { RemoveSpendCapCommand, SpendCapInputCreateCommand } from '../models/state/commands';
import { HashMap } from '../constants';
import { GridSelection } from '../models';
import { ExportSimParameters, PageParameters } from '../models/account';
import { SimManagementError } from '../models/Errors';
import { BasicPageableSearchFilter } from '../models/searchFilter';
import {
  LoadBucketSuccessResponse,
  LoadProvisioningSuccessResponse,
  LoadSimsFailurePayload,
  LoadSimsSuccessPayload,
  LoadStockInfoFailurePayload,
  SimInfo,
  SimsSuccessResponse
} from '../models/sim';
import { Action } from './';
import {
  BULK_SIMS_SELECTED,
  CHANGE_SIMS_SELECTED,
  CLEAR_SIMS,
  DESELECT_SIMS,
  ENSURE_ORANGE_PROVISIONING_ORDER,
  ENSURE_PROVISIONING,
  EXPIRE_SIMS,
  EXPORT_SIMS,
  LOAD_ORANGE_PROVISIONING_ORDER_FAILURE,
  LOAD_ORANGE_PROVISIONING_ORDER_PENDING,
  LOAD_ORANGE_PROVISIONING_ORDER_SUCCESS,
  LOAD_PROVISIONING_FAILURE,
  LOAD_PROVISIONING_PENDING,
  LOAD_PROVISIONING_SUCCESS,
  LOAD_MVNO_BUNDLE_PENDING,
  LOAD_SIMS,
  LOAD_SIMS_FAILURE,
  LOAD_SIMS_IF_NEEDED,
  LOAD_SIMS_PENDING,
  LOAD_SIMS_SUCCESS,
  SET_SELECTED_SIMS,
  SET_VIEWED_SIMS,
  BULK_CONFIGURE_SPEND_CAP,
  BULK_DELETE_SPEND_CAP
} from './actionTypes';
import { RejectFunc, ResolveFunc } from './commonActions';

export function bulkSimsSelected(selectedSims: SimInfo[]) {
  return {
    type: BULK_SIMS_SELECTED,
    payload: selectedSims
  };
}

export function clearSims() {
  return {
    type: CLEAR_SIMS
  };
}

export function deselectSims(payload: SimInfo[]) {
  return {
    type: DESELECT_SIMS,
    payload
  };
}

/**
 * Sets expired = true on the specified sims.
 * Usually this occurs if the stock is now assigned a different tel.
 * @param payload The payload.
 */
export function expireSims(payload: SimInfo[]) {
  return {
    type: EXPIRE_SIMS,
    payload
  };
}

export function loadSims(
  payload: BasicPageableSearchFilter,
  resolve?: ResolveFunc<SimsSuccessResponse>,
  reject?: RejectFunc
) {
  return {
    type: LOAD_SIMS,
    payload,
    resolve,
    reject
  };
}

export function loadSimsIfNeeded(payload: BasicPageableSearchFilter) {
  return {
    type: LOAD_SIMS_IF_NEEDED,
    payload
  };
}

export function loadSimsPending(payload: BasicPageableSearchFilter) {
  return {
    type: LOAD_SIMS_PENDING,
    payload
  };
}

export function loadBucketFailure(stockId: number, error: SimManagementError): Action<LoadStockInfoFailurePayload> {
  return {
    type: LOAD_ORANGE_PROVISIONING_ORDER_FAILURE,
    payload: {
      stockId,
      error
    }
  };
}

export function loadBucketPending(stockId: number) {
  return {
    type: LOAD_ORANGE_PROVISIONING_ORDER_PENDING,
    payload: stockId
  };
}

export function loadBucketSuccess(payload: LoadBucketSuccessResponse) {
  return {
    type: LOAD_ORANGE_PROVISIONING_ORDER_SUCCESS,
    payload
  };
}

export function ensureProvisioning(payload: number) {
  return {
    type: ENSURE_PROVISIONING,
    payload
  };
}

export function loadProvisioningPending(stockId: number) {
  return {
    type: LOAD_PROVISIONING_PENDING,
    payload: stockId
  };
}

export function loadMvnoBundlePending(stockId: number) {
  return {
    type: LOAD_MVNO_BUNDLE_PENDING,
    payload: stockId
  };
}

export function loadSimsSuccess(payload: LoadSimsSuccessPayload) {
  return {
    type: LOAD_SIMS_SUCCESS,
    payload
  };
}

export function loadProvisioningSuccess(payload: LoadProvisioningSuccessResponse) {
  return {
    type: LOAD_PROVISIONING_SUCCESS,
    payload
  };
}

export function loadProvisioningFailure(
  stockId: number,
  error: SimManagementError
): Action<LoadStockInfoFailurePayload> {
  return {
    type: LOAD_PROVISIONING_FAILURE,
    payload: {
      stockId,
      error
    }
  };
}

export function loadSimsFailure(
  searchFilter: BasicPageableSearchFilter,
  error: SimManagementError
): Action<LoadSimsFailurePayload> {
  return {
    type: LOAD_SIMS_FAILURE,
    payload: {
      searchFilter,
      error
    }
  };
}

/**
 * Action which exports an Excel file containing a list of SIM details.
 * @param payload The filter criteria.
 */
export function exportSims(payload: ExportSimParameters): Action<ExportSimParameters> {
  return {
    type: EXPORT_SIMS,
    payload
  };
}

export function changeSimsSelected(payload: GridSelection<SimInfo>[]) {
  return {
    type: CHANGE_SIMS_SELECTED,
    payload
  };
}

export function setSelectedSims(payload: HashMap<SimInfo>) {
  return {
    type: SET_SELECTED_SIMS,
    payload
  };
}

export function setViewedSims(payload: HashMap<SimInfo>) {
  return {
    type: SET_VIEWED_SIMS,
    payload
  };
}

export function setBulkConfigureSpendCap(payload: SpendCapInputCreateCommand) {
  return {
    type: BULK_CONFIGURE_SPEND_CAP,
    payload
  };
}

export function setBulkDeleteSpendCap(payload: RemoveSpendCapCommand) {
  return {
    type: BULK_DELETE_SPEND_CAP,
    payload
  };
}
